export const BIRTHDATE_FIELD_NAME = 'Date of birth';
export const PLACE_OF_BIRTH_FIELD_NAME = 'Place of birth';
export const GENDER_FIELD_NAME = 'Gender';
export const MARITAL_STATUS_FIELD_NAME = 'Marital status';
export const EDUCATION_FIELD_NAME = 'Highest educational attainment';
export const ABROAD_FIELD_NAME = 'Have you ever been abroad?';
export const PREFERRED_LANGUAGE = 'What languages do you speak?';
